import { ref } from "vue";
import {
  onActivated,
  onDeactivated,
  onMounted,
} from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { showToast } from "vant";

import { useMineItemEffect } from "@/views/mine/NewMineItem";
import { getCurrentUserInfo, switchRoleApi } from "@/utils/neturls";
import {
  saveLoginAccessToken,
  saveLoginRefreshToken,
  saveUserInfo,
  getUserInfo,
  logout,
  getUserCompanyName,
  getUserCompanyTypeDesc,
} from "@/utils/localStorageUtils";

const useRoleEffect = (
  t,
  router,
  showAccountPopupFlag,
  getLocalUserInfo,
  updateTranslation
) => {
  const roleList = ref([]);
  const getRoleList = (allUserList) => {
    const roleselectdata = allUserList;
    const showdata = [[], [], [], [], [], [], [], []];
    roleselectdata.forEach((item) => {
      if (item.userType == "SYSTEM_USER") {
        let showitem = {
          session: item.session,
          id: item.id,
          maintitle: t("app.loginroleselect.system_user"),
          fullName: item.fullName,
          flag: "SYSTEM_USER",
          userType: item.userType,
        };
        showdata[0].push(showitem);
      }
      if (item.userType == "SUPPLIER_USER") {
        let showitem = {
          session: item.session,
          id: item.id,
          maintitle: t("app.loginroleselect.supplier_user"),
          fullName: item?.supplier.fullName,
          flag: "SUPPLIER_USER",
          userType: item.userType,
        };
        showdata[1].push(showitem);
      }
      if (item.userType == "DIRECT_VENDOR_USER") {
        let showitem = {
          session: item.session,
          id: item.id,
          maintitle: t("app.loginroleselect.directvendor_user"),
          fullName: item?.directVendor.fullName,
          flag: "DIRECT_VENDOR_USER",
          userType: item.userType,
        };
        showdata[2].push(showitem);
      }

      if (item.userType == "DISTRIBUTOR_USER") {
        let showitem = {
          session: item.session,
          id: item.id,
          maintitle: t("app.loginroleselect.distributor_user"),
          fullName: item?.distributor.fullName,
          flag: "DISTRIBUTOR_USER",
          userType: item.userType,
        };
        showdata[3].push(showitem);
      }
      if (item.userType == "RETAILER_USER") {
        let showitem = {
          session: item.session,
          id: item.id,
          maintitle: t("app.loginroleselect.retailer_user"),
          fullName: item?.retailer.fullName,
          flag: "RETAILER_USER",
          userType: item.userType,
        };
        showdata[4].push(showitem);
      }
      if (item.userType == "SERVICE_PROVIDER_USER") {
        let showitem = {
          session: item.session,
          id: item.id,
          maintitle: t("app.loginroleselect.service_provider_user"),
          fullName: item?.serviceProvider.fullName,
          flag: "SERVICE_PROVIDER_USER",
          userType: item.userType,
        };
        showdata[5].push(showitem);
      }

      if (item.userType == "SERVICE_PERSONNEL") {
        let showitem = {
          session: item.session,
          id: item.id,
          maintitle: t("app.loginroleselect.service_personnel"),
          fullName: item.fullName,
          flag: "SERVICE_PERSONNEL",
          userType: item.userType,
        };
        showdata[6].push(showitem);
      }

      if (item.userType == "INDIVIDUAL_USER") {
        let showitem = {
          session: item.session,
          id: item.id,
          maintitle: t("app.loginroleselect.individual_user"),
          fullName: item.fullName,
          flag: "INDIVIDUAL_USER",
          userType: item.userType,
        };
        showdata[7].push(showitem);
      }
    });
    const result = showdata.filter((item) => item.length > 0);
    roleList.value = result;
  };

  const handleItemClick = async (item) => {
    console.log("handleItemClick item", item);
    const params = {
      userType: item.userType,
      userId: item.id,
    };
    const res = await switchRoleApi(params);
    if (res.error == null) {
      showAccountPopupFlag.value = false;
      saveLoginAccessToken(res.data.token.accessToken);
      saveLoginRefreshToken(res.data.token.refreshToken);

      const currentUser = res.data.currentUser;
      saveUserInfo(currentUser);

      getLocalUserInfo();
      updateTranslation();
    }
  };

  return { roleList, getRoleList, handleItemClick };
};

const useChangeUserEffect = (
  router,
  t,
  getLocalUserInfo,
  updateTranslation
) => {
  const showAccountPopupFlag = ref(false);
  const { roleList, getRoleList, handleItemClick } = useRoleEffect(
    t,
    router,
    showAccountPopupFlag,
    getLocalUserInfo,
    updateTranslation
  );

  const onChangeUser = async () => {
    const params = {
      userTypeList: [
        "INDIVIDUAL_USER",
        "SYSTEM_USER",
        "DISTRIBUTOR_USER",
        "RETAILER_USER",
        "DIRECT_VENDOR_USER",
        "SUPPLIER_USER",
      ],
    };
    const query = params.userTypeList
      .map((id) => `userTypeList=${id}`)
      .join("&");

    const res = await getCurrentUserInfo(query, null);
    if (res.error == null) {
      console.log("res", res);
      if (!res.data) {
        logout();
        router.replace({ name: "Login" });
        return;
      }
      const allUserList = res.data.userList;
      if (allUserList.length <= 1) {
        showToast(t("app.mine.norolecanchagen"));
        return;
      }

      getRoleList(allUserList);
      showAccountPopupFlag.value = true;
    }
  };
  return { onChangeUser, roleList, showAccountPopupFlag, handleItemClick };
};

const useLoginInfoEffect = () => {
  const userName = ref("");
  const roleDesc = ref("");

  const getLocalUserInfo = () => {
    const userInfo = getUserInfo();
    userName.value = userInfo
      ? userInfo.fullName
        ? userInfo.fullName
        : userInfo.nickName
      : "";
    roleDesc.value = getUserCompanyName()
      ? getUserCompanyName() + " (" + getUserCompanyTypeDesc() + ")"
      : "";
  };
  getLocalUserInfo();

  return {
    userName,
    roleDesc,
    getLocalUserInfo,
  };
};

const useShopTopContentEffect = () => {
  const showTopContentFlag = ref(false);

  const changeTopShowContentFunc = () => {
    const userInfo = getUserInfo();
    showTopContentFlag.value = userInfo ? true : false;
  };
  return { showTopContentFlag, changeTopShowContentFunc };
};

export function useMinePage() {
  const router = useRouter();
  const route = useRoute();
  const { from } = route.query;
  const { t } = useI18n();
  const showBackImg = ref(false);
  if (from == "web") {
    showBackImg.value = true;
  }

  const { mineItemList, updateTranslation } = useMineItemEffect(t);

  const { userName, roleDesc, getLocalUserInfo } = useLoginInfoEffect();
  const { showTopContentFlag, changeTopShowContentFunc } =
    useShopTopContentEffect();

  const { onChangeUser, roleList, showAccountPopupFlag, handleItemClick } =
    useChangeUserEffect(router, t, getLocalUserInfo, updateTranslation);

  onMounted(() => {
    console.log("Component is onMounted");
  });
  onActivated(() => {
    console.log("Component is activated");
    updateTranslation();
    getLocalUserInfo();
    changeTopShowContentFunc();
  });

  onDeactivated(() => {
    console.log("Component is deactivated");
  });

  const onBackClick = () => {
    router.back();
  };

  return {
    t,
    mineItemList,
    onChangeUser,
    userName,
    roleDesc,
    showTopContentFlag,
    onBackClick,
    showBackImg,
    roleList,
    showAccountPopupFlag,
    handleItemClick,
  };
}
